import React, { useEffect } from "react";
import { useConnect, useAccount, useDisconnect, useConfig, useChainId, useSwitchChain } from "wagmi";
import { CHAINS } from "../config/contracts";

const ConnectModal = ({ closeModal }) => {
  const { connectors, connect, error, isPending } = useConnect();
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const chainId = useChainId();
  const { switchChain, isPending: isSwitchingChain } = useSwitchChain();

  const config = useConfig();

  const handleWalletConnect = async (connector) => {
    try {
      console.log("Connectors:", config.connectors);
      console.log(
        "Available connectors:",
        config.connectors.map((c) => c.name)
      );
      console.log("Attempting to connect with:", connector.name);

      await connect({ connector });

      console.log("Connection successful");
      // Don't close modal yet - wait for chain switch if needed
    } catch (err) {
      console.error("Connection failed:", err);
    }
  };

  // Check and switch chain after connection
  useEffect(() => {
    if (isConnected && chainId && chainId !== CHAINS.SEPOLIA) {
      // User is connected but on wrong chain, request switch
      try {
        switchChain({ chainId: CHAINS.SEPOLIA });
      } catch (err) {
        console.error("Failed to switch chain:", err);
      }
    } else if (isConnected && chainId === CHAINS.SEPOLIA) {
      // User is connected and on correct chain, close modal
      closeModal();
    }
  }, [isConnected, chainId, switchChain, closeModal]);

  return (
    <>
      <div className="ReactModalPortal">
        <div className="ReactModal__Overlay ReactModal__Overlay--after-open modal-overlay">
          <div
            className="ReactModal__Content ReactModal__Content--after-open modal"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-title">
              <h5>Login to AIFL</h5>
              <button
                className="btn minus"
                data-colors="primary"
                onClick={closeModal}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  role="img"
                  className="iconify iconify--carbon"
                  width="1em"
                  height="1em"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill="currentColor"
                    d="M17.414 16L26 7.414L24.586 6L16 14.586L7.414 6L6 7.414L14.586 16L6 24.586L7.414 26L16 17.414L24.586 26L26 24.586z"
                  ></path>
                </svg>
                <div className="corner" data-colors="primary">
                  <span className="corner-left"></span>
                  <span className="corner-right"></span>
                  <span className="corner-top-bottom"></span>
                </div>
              </button>
            </div>
            <div className="modal-content">
              <div className="grid grid-social">
                <button className="btn" data-colors="primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    role="img"
                    className="iconify iconify--flat-color-icons"
                    width="1em"
                    height="1em"
                    viewBox="0 0 48 48"
                  >
                    <path
                      fill="#FFC107"
                      d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917"
                    ></path>
                    <path
                      fill="#FF3D00"
                      d="m6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C16.318 4 9.656 8.337 6.306 14.691"
                    ></path>
                    <path
                      fill="#4CAF50"
                      d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.9 11.9 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44"
                    ></path>
                    <path
                      fill="#1976D2"
                      d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917"
                    ></path>
                  </svg>
                  <div className="corner" data-colors="primary">
                    <span className="corner-left"></span>
                    <span className="corner-right"></span>
                    <span className="corner-top-bottom"></span>
                  </div>
                </button>
                <button className="btn" data-colors="primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    role="img"
                    className="iconify iconify--logos"
                    width="1em"
                    height="1em"
                    viewBox="0 0 256 256"
                  >
                    <defs>
                      <linearGradient
                        id="iconifyReact0"
                        x1="50%"
                        x2="50%"
                        y1="0%"
                        y2="100%"
                      >
                        <stop offset="0%" stop-color="#2AABEE"></stop>
                        <stop offset="100%" stop-color="#229ED9"></stop>
                      </linearGradient>
                    </defs>
                    <path
                      fill="url(#iconifyReact0)"
                      d="M128 0C94.06 0 61.48 13.494 37.5 37.49A128.04 128.04 0 0 0 0 128c0 33.934 13.5 66.514 37.5 90.51C61.48 242.506 94.06 256 128 256s66.52-13.494 90.5-37.49c24-23.996 37.5-56.576 37.5-90.51s-13.5-66.514-37.5-90.51C194.52 13.494 161.94 0 128 0"
                    ></path>
                    <path
                      fill="#FFF"
                      d="M57.94 126.648q55.98-24.384 74.64-32.152c35.56-14.786 42.94-17.354 47.76-17.441c1.06-.017 3.42.245 4.96 1.49c1.28 1.05 1.64 2.47 1.82 3.467c.16.996.38 3.266.2 5.038c-1.92 20.24-10.26 69.356-14.5 92.026c-1.78 9.592-5.32 12.808-8.74 13.122c-7.44.684-13.08-4.912-20.28-9.63c-11.26-7.386-17.62-11.982-28.56-19.188c-12.64-8.328-4.44-12.906 2.76-20.386c1.88-1.958 34.64-31.748 35.26-34.45c.08-.338.16-1.598-.6-2.262c-.74-.666-1.84-.438-2.64-.258c-1.14.256-19.12 12.152-54 35.686c-5.1 3.508-9.72 5.218-13.88 5.128c-4.56-.098-13.36-2.584-19.9-4.708c-8-2.606-14.38-3.984-13.82-8.41c.28-2.304 3.46-4.662 9.52-7.072"
                    ></path>
                  </svg>
                  <div className="corner" data-colors="primary">
                    <span className="corner-left"></span>
                    <span className="corner-right"></span>
                    <span className="corner-top-bottom"></span>
                  </div>
                </button>
                <button className="btn" data-colors="primary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    aria-hidden="true"
                    role="img"
                    className="iconify iconify--logos"
                    width="1.23em"
                    height="1em"
                    viewBox="0 0 256 209"
                  >
                    <path
                      fill="#55acee"
                      d="M256 25.45a105 105 0 0 1-30.166 8.27c10.845-6.5 19.172-16.793 23.093-29.057a105.2 105.2 0 0 1-33.351 12.745C205.995 7.201 192.346.822 177.239.822c-29.006 0-52.523 23.516-52.523 52.52c0 4.117.465 8.125 1.36 11.97c-43.65-2.191-82.35-23.1-108.255-54.876c-4.52 7.757-7.11 16.78-7.11 26.404c0 18.222 9.273 34.297 23.365 43.716a52.3 52.3 0 0 1-23.79-6.57q-.004.33-.003.661c0 25.447 18.104 46.675 42.13 51.5a52.6 52.6 0 0 1-23.718.9c6.683 20.866 26.08 36.05 49.062 36.475c-17.975 14.086-40.622 22.483-65.228 22.483c-4.24 0-8.42-.249-12.529-.734c23.243 14.902 50.85 23.597 80.51 23.597c96.607 0 149.434-80.031 149.434-149.435q0-3.417-.152-6.795A106.8 106.8 0 0 0 256 25.45"
                    ></path>
                  </svg>
                  <div className="corner" data-colors="primary">
                    <span className="corner-left"></span>
                    <span className="corner-right"></span>
                    <span className="corner-top-bottom"></span>
                  </div>
                </button>
              </div>
              <div className="separator-container">
                <hr className="separator-line" />
                <span className="separator-text">or</span>
                <hr className="separator-line" />
              </div>
              <div className="grid grid-wallet">
                {connectors
                  .filter((connector, index, self) => {
                    // Filter out duplicates: keep only the first occurrence of each connector ID
                    const isFirstOccurrence = index === self.findIndex((c) => c.id === connector.id);
                    // Also filter out io.metamask if metaMask exists (prefer metaMask)
                    if (connector.id === "io.metamask") {
                      return !self.some((c) => c.id === "metaMask");
                    }
                    return isFirstOccurrence;
                  })
                  .map((connector) => {
                    console.log(connector)
                    return (
                  <>
                    <div className="grid-item">
                      <div
                        className="wallet"
                        onClick={() => handleWalletConnect(connector)}
                      >
                        <img 
                            src={
                                connector.id === "metaMask" ? "assets/connectSVG/metamask.svg" 
                                : connector.id === "coinbaseWalletSDK" ? "assets/connectSVG/coinbase.svg" 
                                : connector.id === "bestWallet" ? "assets/connectSVG/bestwallet.svg"
                                : "assets/connectSVG/walletconnect.svg"
                            } 
                        />
                        <h6>{connector.name}</h6>
                        <p>Connect to your {connector.name}</p>
                        <div className="corner" data-colors="tertiary">
                          <span className="corner-left"></span>
                          <span className="corner-right"></span>
                          <span className="corner-top-bottom"></span>
                        </div>
                        <div
                          className="corner corner-hover"
                          data-colors="primary"
                        >
                          <span className="corner-left"></span>
                          <span className="corner-right"></span>
                          <span className="corner-top-bottom"></span>
                        </div>
                      </div>
                    </div>
                  </>
                )})}

              </div>
            </div>
            <div className="corner" data-colors="tertiary">
              <span className="corner-left"></span>
              <span className="corner-right"></span>
              <span className="corner-top-bottom"></span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectModal;
